import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Aggregate,
    ColumnDirective,
    ColumnsDirective,
    GridComponent,
    Inject,
    Sort,
    Resize,
    Toolbar,
    ExcelExport,
    PdfExport,
    ColumnChooser,
    AggregateColumnDirective,
    AggregateColumnsDirective,
    AggregateDirective,
    AggregatesDirective
} from '@syncfusion/ej2-react-grids';
import { MultiSelectComponent, CheckBoxSelection } from '@syncfusion/ej2-react-dropdowns';
import { Button } from 'semantic-ui-react';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import { useTranslation } from 'react-i18next';
import { finishLoading, setTitle, startLoading } from '../../../store/actions/uiAction';
import { logReportService } from '../../../services/logReportService';
import HttpClient from '../../../services/httpClient';
import ComboHotelSala from '../../../components/combo-hotel-sala/combo-hotel-sala';
import styles from './PRProduction.module.scss';

const PRProduction = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.currentUser);
    const { idSaleRoom, idHotel, idUser } = useSelector(state => state.user.param);

    // Estados
    const [dateStart, setDateStart] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(new Date());
    const [rowData, setRowData] = useState([]);
    const [NameSala, setNameSala] = useState([]);
    const [NameHotel, setNameHotel] = useState([]);
    const [NamePrograma, setNamePrograma] = useState([]);
    const [colaboradoresData, setColaboradoresData] = useState([]);
    const [programasData, setProgramasData] = useState([]);
    


    // Referencias
    let mulObjColaboradores = null;
    let mulObjProgramas = null;
    let grid = null;

    // Configuraciones
    const checkFields = { text: 'Name', value: 'Code' };
    const toolbarOptions = ['ColumnChooser'];

    // Manejadores de eventos
    const onChangeDateStart = (event, data) => setDateStart(data.value);
    const onChangeDateEnd = (event, data) => setDateEnd(data.value);

    // Funciones de obtención de datos
    const getDataReport = (url) => {
        dispatch(startLoading());
        return new Promise((resolve, reject) => {
            HttpClient.get(url)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    reject(error);
                });
        });
    };

    const handleViewButton = () => {
        getManifestReport();
    };

    const getColaboradoresData = () => {
        getOptionData('/catalog/colaboradores')
            .then((response) => {
                setColaboradoresData(response);
            });
    };

    const getProgramasData = () => {
        getOptionData('/catalog/programas')
            .then((response) => {
                setProgramasData(response);
            });
    };


    const getOptionData = (url) => {
        return new Promise((resolve, reject) => {
            getData(url).then((response) => {
                if (response.status === 200) {
                    const obj = response.data;
                    const res = obj.map(item => ({
                        Code: item.id,
                        Name: item.name
                    }));
                    resolve(res);
                }
            }).catch(error => {
                reject(error);
            });
        });
    };

    const getData = (url, data) => {
        dispatch(startLoading());
        return new Promise((resolve, reject) => {
            HttpClient.get(url, data)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    reject(error);
                });
        });
    };

    const getManifestReport = () => {
        const date1 = dateStart.toISOString().slice(0, 10).replace(/-/g, '');
        const date2 = dateEnd.toISOString().slice(0, 10).replace(/-/g, '');
        const programas = (mulObjProgramas?.value?.length > 0)
            ? mulObjProgramas.value.map(String).toString()
            : '0';
        const colaboradores = (mulObjColaboradores?.value?.length > 0)
            ? mulObjColaboradores.value.map(String).toString()
            : '0';

        getDataReport(`/catalog/getNameSalavtaId/${idSaleRoom}`).then((response) => {
            if (response.status === 200) {
                setNameSala(response.data);
            }
        });

        getDataReport(`/catalog/getNameHotelId/${idHotel}`).then((response) => {
            if (response.status === 200) {
                setNameHotel(response.data);
            }
        });

        getDataReport(`/catalog/getNameProgramaId/${programas}`).then((response) => {
            if (response.status === 200) {
                console.log(response.data);
                
                setNamePrograma(response.data);
            }
        })



        getDataReport(`/reports/pr-production/${date1}/${date2}/${idSaleRoom}/${idHotel}/${colaboradores}/${programas}`)
            .then((response) => {
                if (response.status === 200) {
                    setRowData(response.data);
                    logReportService.add('PR-Production Report', user);
                }
            });
    };

    // Funciones de exportación
    const handleExport2Excel = () => {
        if (grid) {
            export2Excel();
        }
    };

    const export2Excel = () => {
        const date1 = dateStart.toDateString();
        const date2 = dateEnd.toDateString();
        const excelExportProperties = {
            fileName: `${t('menusidebar.label.pr-production')}.xlsx`,
            theme: {
                caption: { fontName: 'Calibri', fontColor: '#666666', fontSize: 13 },
                header: { fontName: 'Calibri', fontColor: '#000000', backColor: '#3F97BF', fontSize: 13 }
            },
            header: {
                headerRows: 7,
                rows: [
                    {
                        cells: [{
                            colSpan: 4,
                            value: `LVC KCS ${t('menusidebar.label.pr-production')}`,
                            style: { fontColor: '#000000', fontSize: 16, hAlign: 'Left', bold: true }
                        }]
                    },
                    {
                        cells: [{
                            colSpan: 4,
                            value: `SALES ROOM: ${NameSala.name || ''}`,
                            style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true }
                        }]
                    },
                    {
                        cells: [{
                            colSpan: 4,
                            value: `HOTELS: ${NameHotel.name || ''}`,
                            style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true }
                        }]
                    },
                    { 
                        cells: [{ 
                            colSpan: 4, 
                            value: "PROGRAMS: " + NamePrograma[0]["name"], 
                            style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] 
                    },
                    {
                        cells: [{
                            colSpan: 4,
                            value: `${date1} - ${date2}`,
                            style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true }
                        }]
                    }, 
                    
                   
                ]
            }
        };
        if (grid) {
            grid.excelExport(excelExportProperties);
        }
    };

    const handleToolbarClick = (args) => {
        if (grid && args.item.id === 'grid_excelexport') {
            export2Excel();
        } else {
            if (grid && args.item.id === 'grid_pdfexport') {
                grid.pdfExport();
            }
        }
    };

    const dataBound = () => {
        if (grid) {
            grid.autoFitColumns();
        }
    };

    // Funciones de agregación
    function footerSum(props) {
        return <span>{props.Sum}</span>;
    }

    const footerArrivalSum = (props) => <span>{props.Sum}</span>;

    const footeAvailsSum = (props) => <span>{props.Sum}</span>;

    function footerAverage(props) {
        return <span>{props.Average}</span>;
    }

    function custom(props) {
        return <span>{props.Custom}</span>;
    }




    function customAggregateFnSh() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['sh'];
            totalSum2 += gridData[i]['bk'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

    function customAggregateFnCl() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['cancelled'];
            totalSum2 += gridData[i]['totalSales'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

    function customAggregateFnEff() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['totalVolume'];
            totalSum2 += gridData[i]['tShows'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

    function customAggregateFnEffQs() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['volumenqs'];
            totalSum2 += gridData[i]['qs'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }


    function customAggregateFnClo() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['totalSales'];
            totalSum2 += gridData[i]['tShows'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

    function customAggregateFnCloQs() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['salesqs'];
            totalSum2 += gridData[i]['qs'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

    function customAggregateFnAvg() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['totalVolume'];
            totalSum2 += gridData[i]['totalSales'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

    function customAggregateFnAvgQs() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['volumenqs'];
            totalSum2 += gridData[i]['salesqs'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

    function customAggregateFnCloQfs() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['salesqfs'];
            totalSum2 += gridData[i]['qfs'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

    function customAggregateFnEffQfs() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['volumenqfs'];
            totalSum2 += gridData[i]['qfs'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

    function customAggregateFnAvgQfs() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['volumenqfs'];
            totalSum2 += gridData[i]['salesqfs'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

    function customAggregateFnCloNqfs() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['salesnqfs'];
            totalSum2 += gridData[i]['nqfs'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

       function customAggregateFnCloNqes() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['salesnqes'];
            totalSum2 += gridData[i]['nqes'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

    function customAggregateFnEffNqfs() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['volumennqfs'];
            totalSum2 += gridData[i]['nqfs'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }


      function customAggregateFnEffNqes() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['volumennqes'];
            totalSum2 += gridData[i]['nqes'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

    function customAggregateFnAvgNqfs() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['volumennqfs'];
            totalSum2 += gridData[i]['salesnqfs'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

        function customAggregateFnAvgNqes() {
        if (!grid || !grid.dataSource) return 0;
        const gridData = grid.dataSource;
        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < gridData.length; i++) {
            totalSum1 += gridData[i]['volumennqes'];
            totalSum2 += gridData[i]['salesnqes'];
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

    

    // Efectos
    useEffect(() => {
        getColaboradoresData();
        getProgramasData();
        dispatch(setTitle(t('menusidebar.label.pr-production')));
    }, []);

    return (
        <div className={`container-fluid ${styles.prProductionContainer}`}>
            <ComboHotelSala />

            {/* Filtros */}
            <div className={`row ${styles.filterSection}`}>

                  {/* Fecha inicio */}
                <div className={`col-12 col-sm-6 col-md-4 col-lg-3 ${styles.filterColumn}`}>
                    <label className={styles.formLabel}>Fecha inicio:</label>
                    <SemanticDatepicker
                        className="w-100"
                        name="dateStart"
                        value={dateStart}
                        onChange={onChangeDateStart}
                    />
                </div>

                {/* Fecha fin */}
                <div className={`col-12 col-sm-6 col-md-4 col-lg-3 ${styles.filterColumn}`}>
                    <label className={styles.formLabel}>Fecha fin:</label>
                    <SemanticDatepicker
                        className="w-100"
                        name="dateEnd"
                        value={dateEnd}
                        onChange={onChangeDateEnd}
                    />
                </div>
                {/* Staff/Colaboradores */}
                <div className={`col-12 col-sm-6 col-md-4 col-lg-3 ${styles.filterColumn}`}>
                    <label className={styles.formLabel}>Staff:</label>
                    <MultiSelectComponent
                        id="colaboradores"
                        ref={(scope) => { mulObjColaboradores = scope; }}
                        dataSource={colaboradoresData}
                        fields={checkFields}
                        placeholder="Seleccionar colaboradores"
                        mode="CheckBox"
                        showSelectAll={true}
                        value={[]}
                        showDropDownIcon={true}
                        allowFiltering={true}
                        filterBarPlaceholder="Buscar colaborador"
                        popupHeight="350px"
                    >
                        <Inject services={[CheckBoxSelection]} />
                    </MultiSelectComponent>
                </div>

                {/* Programas */}
                <div className={`col-12 col-sm-6 col-md-4 col-lg-3 ${styles.filterColumn}`}>
                    <label className={styles.formLabel}>Programas:</label>
                    <MultiSelectComponent
                        id="programas"
                        ref={(scope) => { mulObjProgramas = scope; }}
                        dataSource={programasData}
                        fields={checkFields}
                        placeholder="Seleccionar programas"
                        mode="CheckBox"
                        showSelectAll={true}
                        value={[]}
                        showDropDownIcon={true}
                        filterBarPlaceholder="Buscar programa"
                        popupHeight="350px"
                    >
                        <Inject services={[CheckBoxSelection]} />
                    </MultiSelectComponent>
                </div>

              

                {/* Botones */}
                <div className={`col-12 col-md-8 col-lg-6 ${styles.filterColumn}`}>
                    <div className={styles.buttonGroup}>
                        <Button primary onClick={handleViewButton}>
                            Ver Reporte
                        </Button>
                        <Button positive onClick={handleExport2Excel}>
                            Exportar Reporte
                        </Button>
                    </div>
                </div>
            </div>

            {/* Grid */}
            <div>
                <GridComponent id="grid" height='100%' width='auto'
                    dataSource={rowData}
                    allowSorting={true}
                    allowResizing={true}
                    allowExcelExport={true}
                    allowPdfExport={false}
                    showColumnChooser={true}
                    toolbar={toolbarOptions}                   
                    toolbarClick={handleToolbarClick}
                    dataBound={dataBound}
                    ref={g => grid = g}
                >
                    <Inject services={[Sort, Toolbar, Resize, ExcelExport, PdfExport, Aggregate,ColumnChooser]} />
                    <ColumnsDirective>
                        <ColumnDirective field='rownum' headerText="Num" minWidth='5' textAlign="Right" />
                        <ColumnDirective field='prId' headerText="N.Colab" width='10' textAlign="Right" />
                        <ColumnDirective field='prName' headerText="PR Name" width='30' textAlign="Left" />
                        <ColumnDirective field='bk' headerText="Bk" width='10' textAlign="Right"  />
                        <ColumnDirective field='sh' headerText="Sh" width='20' textAlign="Right" />
                        <ColumnDirective field='shFactor' headerText="Sh %" width='20' textAlign="Right" format="P2" />
                        <ColumnDirective field='dir' headerText="Dir" width='20' textAlign="Right"  />
                        <ColumnDirective field='tShows' headerText="T.Shows" width='20' textAlign="Right"  />
                        <ColumnDirective field='qs' headerText="Qs" width='20' textAlign="Right" />
                        <ColumnDirective field='q1s' headerText="Q1s" width='20' textAlign="Right" />
                        <ColumnDirective field='qfs' headerText="Qfs" width='20' textAlign="Right" />
                        <ColumnDirective field='nqs' headerText="NQs" width='20' textAlign="Right" />
                        <ColumnDirective field='nqfs' headerText="NQfs" width='20' textAlign="Right" />
                        <ColumnDirective field='nqes' headerText="NQEs" width='20' textAlign="Right" />
                    
                        <ColumnDirective field='ct' headerText="CTs" width='20' textAlign="Right" />
                        <ColumnDirective field='safes' headerText="SAFEs" width='20' textAlign="Right" />
                        <ColumnDirective field='sales' headerText="# Sales" width='20' textAlign="Right"  />
                        <ColumnDirective field='processable' headerText="Processable" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='oop' headerText="# OOP" width='20' textAlign="Right" />
                        <ColumnDirective field='oopVolume' headerText="OOP" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='cancelled' headerText="# C" width='20' textAlign="Right"  />
                        <ColumnDirective field='cancelledVolume' headerText="Cancelled" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='cancelPercent' headerText="C%" width='20' textAlign="Right" format="P2" />
                        <ColumnDirective field='totalSales' headerText="Total Sales" width='20' textAlign="Right" />
                        <ColumnDirective field='totalVolume' headerText="Total Volume" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='closingPercent' headerText="%CL shows" width='20' textAlign="Right" format="P2" />
                        <ColumnDirective field='eff' headerText="VPG Shows" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='avg' headerText="Avg sale" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='salesqs' headerText="Sales Qs #" width='20' textAlign="Right" format="N2" />
                        <ColumnDirective field='volumenqs' headerText="Volumen Qs #" width='20' textAlign="Right" format="N2" />
                        <ColumnDirective field='closingpercentqs' headerText="%CL Qs" width='20' textAlign="Right" format="P2" />
                        <ColumnDirective field='effqs' headerText="VPG Qs" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='avgqs' headerText="Avg Qs" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='salesqfs' headerText="Sales Qfs #" width='20' textAlign="Right" format="N2" />
                        <ColumnDirective field='volumenqfs' headerText="Volumen Qfs" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='closingpercentqfs' headerText="%CL Qfs" width='20' textAlign="Right" format="P2" />
                        <ColumnDirective field='effqfs' headerText="VPG Qfs" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='avgqfs' headerText="Avg Qfs" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='salesnqfs' headerText="Sales NQfs #" width='20' textAlign="Right" format="N2" />
                        <ColumnDirective field='volumennqfs' headerText="Volumen NQfs" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='closingpercentnqfs' headerText="%CL NQfs" width='20' textAlign="Right" format="P2" />
                        <ColumnDirective field='effnqfs' headerText="VPG NQfs" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='avgnqfs' headerText="Avg NQfs" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='salesnqes' headerText="Sales NQEs #" width='20' textAlign="Right" format="N2" />
                        <ColumnDirective field='volumennqes' headerText="Volumen NQEs" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='closingpercentnqes' headerText="%CL NQEs" width='20' textAlign="Right" format="P2" />
                        <ColumnDirective field='effnqes' headerText="VPG NQEs" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='avgnqes' headerText="Avg NQEs" width='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='pending' headerText="# Pending" width='20' textAlign="Right" />
                        <ColumnDirective field='pendingVolume' headerText="Pending" width='20' textAlign="Right" format="C2" />
                    </ColumnsDirective>
                    <AggregatesDirective>
                        <AggregateDirective>
                            <AggregateColumnsDirective>
                                <AggregateColumnDirective field='bk' type='Sum' customAggregate={footerArrivalSum} />
                                <AggregateColumnDirective field='sh' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='shFactor' type='Custom' format='P2' customAggregate={customAggregateFnSh} />
                                <AggregateColumnDirective field='dir' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='tShows' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='qs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='q1s' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='qfs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='nqs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='nqfs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='nqes' type='Sum' customAggregate={footeAvailsSum} />
                                
                                <AggregateColumnDirective field='ct' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='safes' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='sales' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='processable' format="C2" type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='oop' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='oopVolume' format="C2" type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='cancelled' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='cancelledVolume' format="C2" type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='cancelPercent' type='Custom' format='P2' customAggregate={customAggregateFnCl} />
                                <AggregateColumnDirective field='totalSales' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='totalVolume' type='Sum' format="C2" customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='closingPercent' type='Custom' format='P2' customAggregate={customAggregateFnClo} />
                                <AggregateColumnDirective field='eff' type='Custom' format="C2" customAggregate={customAggregateFnEff} />
                                <AggregateColumnDirective field='salesqs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='volumenqs' type='Sum'  format="C2"  customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='closingpercentqs' type='Custom' format='P2' customAggregate={customAggregateFnCloQs} />
                                <AggregateColumnDirective field='effqs' type='Custom' format="C2" customAggregate={customAggregateFnEffQs} />
                                <AggregateColumnDirective field='avg' type='Custom' format="C2" customAggregate={customAggregateFnAvg} />
                                <AggregateColumnDirective field='avgqs' type='Custom' format="C2" customAggregate={customAggregateFnAvgQs} />
                                <AggregateColumnDirective field='salesqfs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='volumenqfs' type='Sum' format="C2" customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='closingpercentqfs' type='Custom' format='P2' customAggregate={customAggregateFnCloQfs} />
                                <AggregateColumnDirective field='effqfs' type='Custom' format="C2" customAggregate={customAggregateFnEffQfs} />
                                <AggregateColumnDirective field='avgqfs' type='Custom' format="C2" customAggregate={customAggregateFnAvgQfs} />
                                <AggregateColumnDirective field='salesnqfs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='volumennqfs' type='Sum' format="C2" customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='closingpercentnqfs' type='Custom' format='P2' customAggregate={customAggregateFnCloNqfs} />
                                <AggregateColumnDirective field='effnqfs' type='Custom' format="C2" customAggregate={customAggregateFnEffNqfs} />
                                <AggregateColumnDirective field='avgnqfs' type='Custom' format="C2" customAggregate={customAggregateFnAvgNqfs} />
                                <AggregateColumnDirective field='salesnqes' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='volumennqes' type='Sum' format="C2" customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='closingpercentnqes' type='Custom' format='P2' customAggregate={customAggregateFnCloNqes} />
                                <AggregateColumnDirective field='effnqes' type='Custom' format="C2" customAggregate={customAggregateFnEffNqes} />
                                <AggregateColumnDirective field='avgnqes' type='Custom' format="C2" customAggregate={customAggregateFnAvgNqes} />
                               
                               <AggregateColumnDirective field='pending' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='pendingVolume' type='Sum' format="C2" customAggregate={footerSum} />
                            </AggregateColumnsDirective>
                        </AggregateDirective>
                    </AggregatesDirective>
                </GridComponent>
            </div>
        </div>
    );
};

export default PRProduction;
